import * as React from 'react';
import { PaymentApi } from './paymentApi';
import { LocalStorage } from './localStorage';

interface IProps {
  paymentApi: PaymentApi;
  localStorage: LocalStorage;
  children: React.ReactNode;
}

interface PaymentServices {
  paymentApi: PaymentApi;
  localStorage: LocalStorage;
}

const PaymentServiceContext = React.createContext<PaymentServices | null>(null);

export const PaymentServiceProvider = ({ paymentApi, children, localStorage }: IProps) => {
  return (
    <PaymentServiceContext.Provider value={{ paymentApi, localStorage }}>{children}</PaymentServiceContext.Provider>
  );
};

export function usePaymentServices(): PaymentServices {
  const config = React.useContext(PaymentServiceContext);
  if (config === null) {
    throw new Error('PaymentServiceContext is not available, wrap your component with PaymentServiceProvider');
  }
  return config;
}
